// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__QrCL1","image":"recipe_image__l5biy","theingredient":"recipe_theingredient__3e3t9","calories":"recipe_calories__2k3LP","title":"recipe_title__LKbNK"};